/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  text: string | undefined;
};

export const GoodsName: FcWithoutChildren<Props> = (props) => {
  const { text } = props;

  if (text === undefined) return null;

  return <h2 css={rootStyles}>{text}</h2>;
};

// TODO: margin-bottom の指定は feature flag 解除時には不要になる
//  !important しないと現行スタイルの上書きができない
const rootStyles = css`
  color: #000;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  margin-bottom: 0 !important;
`;
